import React, { useEffect, useState } from 'react';

import { supabase, useAuth } from 'hooks/useAuth';
import { useToast } from 'hooks/useToast';
import { useResponsiveScreenSizes } from 'hooks/useResponsiveScreenSizes';

import { Database } from 'libs/supabaseTypes';

import { MarkdownWrapper } from 'components/ui/MarkdownWrapper';
import { Loader } from 'components/ui/Loader';

import { Fonts } from 'styles/theme';
import { Bumper, NestedCard } from 'styles/shared';

export type GuidelineData = Database['public']['Tables']['guidelines']['Row'];

interface GuidelinesContainerProps {
    guidelinesTitle: string;
}

export const GuidelinesContainer = ({
    guidelinesTitle,
}: GuidelinesContainerProps) => {
    const { userId } = useAuth();
    const { showErrorToast } = useToast();
    const { isMobileScreenSize } = useResponsiveScreenSizes();

    const [guideline, setGuideline] = useState<GuidelineData | null>(null);

    useEffect(() => {
        const getGuidelines = async () => {
            const { data, error } = await supabase
                .from('guidelines')
                .select('*')
                .eq('title', guidelinesTitle)
                .maybeSingle();

            if (error == null && data != null) {
                setGuideline(data);
            } else {
                showErrorToast(error?.message ?? 'Failed to fetch guidelines');
            }
        };

        if (userId !== '') {
            getGuidelines();
        }
    }, [guidelinesTitle, showErrorToast, userId]);

    return guideline == null ? (
        <Loader />
    ) : (
        <>
            {isMobileScreenSize ? (
                <Fonts.Heading6>{guideline.title}</Fonts.Heading6>
            ) : (
                <Fonts.Heading5>{guideline.title}</Fonts.Heading5>
            )}
            <Bumper />
            <NestedCard>
                <MarkdownWrapper markdownString={guideline.content} />
            </NestedCard>
        </>
    );
};
